import axios from 'axios';
import { getApiUrl } from '@/config/api';
import authService from '@/shared/services/auth';

class CatMaterialAlmacenService {
  constructor() {
    this.materialAlmacenes = [];
    this.loading = false;
    this.error = null;
    this.selectedEmpresa = null;
  }

  async initialize() {
    // Esperar un poco para que la empresa se seleccione
    await this.waitForEmpresa();
    await this.listar();
  }

  // Esperar a que la empresa esté seleccionada
  async waitForEmpresa() {
    let attempts = 0;
    const maxAttempts = 50; // 5 segundos máximo
    
    while (attempts < maxAttempts) {
      this.selectedEmpresa = authService.getSelectedEmpresa();
      if (this.selectedEmpresa && this.selectedEmpresa.EmpresaId) {
        console.log('Empresa encontrada para CatMaterialAlmacen:', this.selectedEmpresa);
        return;
      }
      
      // Esperar 100ms antes del siguiente intento
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }
    
    // Si no se encuentra empresa después de los intentos
    this.error = 'No se pudo obtener la empresa seleccionada';
    console.error('No se pudo obtener empresa para CatMaterialAlmacen después de', maxAttempts, 'intentos');
  }

  async listar() {
    this.loading = true;
    this.error = null;
    
    try {
      // Verificar que tenemos empresa seleccionada
      if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
        this.selectedEmpresa = authService.getSelectedEmpresa();
        if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
          this.loading = false;
          return { success: false, data: [], message: 'Debe elegir una empresa antes de poder continuar.' };
        }
      }

      const token = authService.getToken();
      const response = await axios.post(getApiUrl('/api/CatMaterialAlmacen/listar'), {
        EmpresaId: this.selectedEmpresa.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      
      // Filtrar por empresa en el frontend como medida de seguridad adicional
      const allMaterialAlmacenes = response.data || [];
      this.materialAlmacenes = allMaterialAlmacenes.filter(materialAlmacene => materialAlmacene.EmpresaId === this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('MaterialAlmacenes cargados:', this.materialAlmacenes.length, 'de', allMaterialAlmacenes.length, 'total');
      console.log('Empresa del usuario:', this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Materiales en Almacenes cargados:', this.materialAlmacenes.length);
      
      return {
        success: true,
        data: this.materialAlmacenes,
        message: 'Materiales en Almacenes cargados exitosamente'
      };
    } catch (error) {
      console.error('Error al cargar Materiales en Almacenes:', error);
      this.error = error.message;
      this.materialAlmacenes = [];
      this.loading = false;
      throw error;
    }
  }

  async guardar(materialAlmacenData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...materialAlmacenData,
        EmpresaId: selectedEmpresa?.EmpresaId || materialAlmacenData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatMaterialAlmacen/guardar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Material en Almacén guardado exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar Material en Almacén:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al guardar Material en Almacén'
      };
    }
  }

  async borrar(materialAlmacenData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...materialAlmacenData,
        EmpresaId: selectedEmpresa?.EmpresaId || materialAlmacenData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatMaterialAlmacen/borrar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Material en Almacén eliminado exitosamente'
      };
    } catch (error) {
      console.error('Error al eliminar Material en Almacén:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al eliminar Material en Almacén'
      };
    }
  }

  async lectura(materialClave, almacenClave) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatMaterialAlmacen/lectura'), {
        MaterialClave: materialClave,
        AlmacenClave: almacenClave,
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error al leer Material en Almacén:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al leer Material en Almacén'
      };
    }
  }

  async recargar() {
    await this.listar();
  }

  async downloadBulk() {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatMaterialAlmacen/descarga-masiva'), {
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      });

      // Crear enlace de descarga
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `materiales_almacenes_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        message: 'Descarga iniciada correctamente'
      };
    } catch (error) {
      console.error('Error al descargar Materiales en Almacenes:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al descargar Materiales en Almacenes'
      };
    }
  }

  // Verificar si hay empresa seleccionada
  get hasEmpresa() {
    return this.selectedEmpresa && this.selectedEmpresa.EmpresaId;
  }
}

export default CatMaterialAlmacenService;
